import { H2, P, Text } from '@mxenabled/mxui'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import type { SxProps } from '@mui/material/styles'

interface StatusIndicatorProps {
  amount: string | React.ReactNode
  borderRadius?: string
  completeColor?: string
  count?: string
  icon: React.ReactNode
  label: string | React.ReactNode
  leftLabel?: string
  percentComplete?: number
  rightLabel?: string
  sx?: SxProps
}

const StatusIndicator = ({
  amount,
  borderRadius = '2px',
  count,
  completeColor = 'success.main',
  icon,
  label,
  leftLabel,
  percentComplete = 0,
  rightLabel,
  sx,
}: StatusIndicatorProps) => {
  return (
    <Stack className="details-container" sx={{ p: 24, width: '100%', gap: 16, ...sx }}>
      <Stack sx={{ alignItems: 'center', flexDirection: 'row', gap: 12 }}>
        <Box>{icon}</Box>
        <Stack>
          {typeof label === 'string' ? (
            <P dangerouslySetInnerHTML={{ __html: label }} variant={'body2'} />
          ) : (
            label
          )}
          {typeof amount === 'string' ? <H2>{amount}</H2> : amount}
        </Stack>
      </Stack>
      <Stack sx={{ gap: 4 }}>
        <Stack
          sx={{
            bgcolor: 'divider',
            borderRadius,
            flexDirection: 'row',
            height: count ? 20 : 16,
            width: '100%',
          }}
        >
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              py: 2,
              px: 12,
              bgcolor: completeColor,
              borderRadius,
              height: count ? 20 : 16,
              width: `${percentComplete}%`,
            }}
          >
            <Text sx={{ color: 'primary.dark' }} variant="caption">
              {count}
            </Text>
          </Box>
        </Stack>
        {!count && (
          <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text variant="body2">{leftLabel}</Text>
            <Text variant="body2">{rightLabel}</Text>
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}

export default StatusIndicator
